export const PiecesUom = [ 'pcs', 'crt' ] as const;
export type PiecesUom = typeof PiecesUom[number];

export const DimsUom = [ 'in', 'ft', 'cm', 'm' ] as const;
export type DimsUom = typeof DimsUom[number];

export const WeightsUom = [ 'lbs', 'kgs' ] as const;
export type WeightsUom = typeof WeightsUom[number];

export const VolumesUom = [ 'cft', 'cbm' ] as const;
export type VolumesUom = typeof VolumesUom[number];

const convert = {
   // DimsUom
   ftin: 12,
   inft:  1 / 12,
   incm: 2.54 ,
   cmin: 1 / 2.54,
   mcm: 100,
   cmm: 1 / 100,

   get inm() {
      return this.incm * this.cmm;
   },
   get ftcm() {
      return this.ftin * this.incm;
   },
   get cmft() {
      return this.cmin * this.inft;
   },
   get min() {
      return this.mcm * this.cmin;
   },

   get mft() {
      return this.mcm / this.incm / this.ftin;
   },
   get ftm() {
      return 1 / this.mft;
   },

   // VolumesUom
   get cftcbm() {
      return Math.pow( this.ftm, 3 );
   },
   get cbmcft() {
      return Math.pow( this.mft, 3 );
   },

   // WeightsUom
   lbskgs: 0.45359237,
   kgslbs: 2.20462262,
};

export type ConvertableValues = DimsUom | WeightsUom | VolumesUom;

// Normalize weight units to handle both singular and plural forms
function normalizeUnit( unit: string ): string {
   const normalized = unit?.toLowerCase();
   if ( normalized === 'lb' || normalized === 'lbs' ) { return 'lbs'; }
   if ( normalized === 'kg' || normalized === 'kgs' ) { return 'kgs'; }
   return unit;
}

export function Convert( amount: number, from: ConvertableValues, to: ConvertableValues ): number {
   const normalizedFrom = normalizeUnit( from );
   const normalizedTo = normalizeUnit( to );
   return ( amount * ( convert[ normalizedFrom + normalizedTo ] ?? 1 ));
}
